'use strict';

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var itPeekable = require('it-peekable');

var browserStreamToIt = require('browser-readablestream-to-it');

var all = require('it-all');

var _require = require('./utils'),
    isBytes = _require.isBytes,
    isBlob = _require.isBlob,
    isReadableStream = _require.isReadableStream;
/**
 * @param {import('./normalise-input').ToContent} input
 * @returns {Promise<Blob>}
 */


function toBlob(_x) {
  return _toBlob.apply(this, arguments);
}
/**
 * @param {AsyncIterable<BlobPart>|Iterable<BlobPart>} stream
 * @returns {Promise<Blob>}
 */


function _toBlob() {
  _toBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var peekable, _yield$peekable$peek, value, done;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isBytes(input)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", new Blob([input]));

          case 2:
            if (!(typeof input === 'string' || input instanceof String)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", new Blob([input.toString()]));

          case 4:
            if (!isBlob(input)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", input);

          case 6:
            // Browser stream
            if (isReadableStream(input)) {
              input = browserStreamToIt(input);
            } // (Async)Iterator<?>


            if (!(input[Symbol.iterator] || input[Symbol.asyncIterator])) {
              _context2.next = 28;
              break;
            }

            /** @type {any} peekable */
            peekable = itPeekable(input);
            /** @type {any} value **/

            _context2.next = 11;
            return peekable.peek();

          case 11:
            _yield$peekable$peek = _context2.sent;
            value = _yield$peekable$peek.value;
            done = _yield$peekable$peek.done;

            if (!done) {
              _context2.next = 16;
              break;
            }

            return _context2.abrupt("return", itToBlob(peekable));

          case 16:
            peekable.push(value); // (Async)Iterable<Number>

            if (!Number.isInteger(value)) {
              _context2.next = 26;
              break;
            }

            _context2.t0 = Blob;
            _context2.t1 = Uint8Array;
            _context2.next = 22;
            return all(peekable);

          case 22:
            _context2.t2 = _context2.sent;
            _context2.t3 = _context2.t1.from.call(_context2.t1, _context2.t2);
            _context2.t4 = [_context2.t3];
            return _context2.abrupt("return", new _context2.t0(_context2.t4));

          case 26:
            if (!(isBytes(value) || typeof value === 'string' || value instanceof String)) {
              _context2.next = 28;
              break;
            }

            return _context2.abrupt("return", itToBlob(peekable));

          case 28:
            throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _toBlob.apply(this, arguments);
}

function itToBlob(stream) {
  var parts, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

  return _regeneratorRuntime.async(function itToBlob$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          parts = [];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _context.prev = 3;
          _iterator = _asyncIterator(stream);

        case 5:
          _context.next = 7;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 7:
          _step = _context.sent;
          _iteratorNormalCompletion = _step.done;
          _context.next = 11;
          return _regeneratorRuntime.awrap(_step.value);

        case 11:
          _value = _context.sent;

          if (_iteratorNormalCompletion) {
            _context.next = 18;
            break;
          }

          chunk = _value;
          parts.push(chunk);

        case 15:
          _iteratorNormalCompletion = true;
          _context.next = 5;
          break;

        case 18:
          _context.next = 24;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](3);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 24:
          _context.prev = 24;
          _context.prev = 25;

          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
            _context.next = 29;
            break;
          }

          _context.next = 29;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 29:
          _context.prev = 29;

          if (!_didIteratorError) {
            _context.next = 32;
            break;
          }

          throw _iteratorError;

        case 32:
          return _context.finish(29);

        case 33:
          return _context.finish(24);

        case 34:
          return _context.abrupt("return", new Blob(parts));

        case 35:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[3, 20, 24, 34], [25,, 29, 33]], Promise);
}

module.exports = toBlob;